import React from 'react';
import { withStyles } from 'material-ui/styles';
import SearchPiece from './search_piece.js';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'block',
  },
  title : {
    fontSize: 12,
    lineHeight: '18px',    
    fontWeight: 'bold',
    display: 'block',
  },  
  data: {
    fontSize: 8,
    lineHeight: '12px',    
    display : 'block',
    wordWrap: 'break-word',
    marginBottom: 5,
  },
  block : {
    display : 'block',
  },
  link: {
    textDecoration: 'none',
  },  
});


class SearchPieceGeneric extends SearchPiece {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const classes = this.props.classes;
    const items = this.getData(this.props.item.pagemap, this.props.section);
    var key = 0;

    return (
      <div>
        <div className={classes.title}>{this.props.section}</div>
        <hr/>
        {items.map(data=>
          <div key={key++}>
            {data.map(item=>
              <span key={key++} className={classes.data}><b>{item.name}:</b> {item.value}</span>
            )}
            <hr/>
          </div>
        )}
      </div>
    );
  }              

  getTitle(){

  }
}

export default withStyles(styles)(SearchPieceGeneric);


// WEBPACK FOOTER //
// ./src/search/pieces/search_piece_generic.js